(function () {
  if (window.ToyvixCollectorVideos) {
    window.ToyvixCollectorVideos.init();
    return;
  }

  function videoSource(button) {
    var provider = button.dataset.provider;
    var id = button.dataset.externalId;
    if (provider === 'youtube' && /^[A-Za-z0-9_-]{11}$/.test(id || '')) {
      return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    }
    if (provider === 'vimeo' && /^\d+$/.test(id || '')) {
      return 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1';
    }
    var raw = button.dataset.videoUrl || button.dataset.bilibiliUrl || '';
    var url;
    try { url = new URL(raw); } catch (error) { return ''; }
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
    var host = url.hostname.toLowerCase();
    var youtubeId = '';
    if (host === 'youtu.be' || host === 'www.youtu.be') youtubeId = url.pathname.split('/')[1];
    if (host === 'youtube.com' || host === 'www.youtube.com' || host === 'm.youtube.com') {
      youtubeId = url.searchParams.get('v') || '';
      if (!youtubeId) youtubeId = url.pathname.match(/^\/(?:shorts|embed|live)\/([A-Za-z0-9_-]{11})/)?.[1] || '';
    }
    if (/^[A-Za-z0-9_-]{11}$/.test(youtubeId)) {
      return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(youtubeId) + '?autoplay=1&rel=0';
    }
    if (host === 'vimeo.com' || host === 'www.vimeo.com' || host === 'player.vimeo.com') {
      var vimeoId = url.pathname.match(/\/(?:video\/)?(\d+)(?:\/|$)/)?.[1];
      if (vimeoId) return 'https://player.vimeo.com/video/' + encodeURIComponent(vimeoId) + '?autoplay=1';
    }
    if (host === 'bilibili.com' || host === 'www.bilibili.com' || host === 'm.bilibili.com') {
      var bvid = url.pathname.match(/\/video\/(BV[A-Za-z0-9]+)/i)?.[1];
      if (bvid) return 'https://player.bilibili.com/player.html?bvid=' + encodeURIComponent(bvid) + '&autoplay=1';
    }
    return '';
  }

  function closePlayer(player) {
    player.querySelector('[data-video-player-content]').replaceChildren();
    player.hidden = true;
    var button = player.closest('.collector-video-card__media').querySelector('[data-video-play]');
    if (button) button.focus();
  }

  document.addEventListener('click', function (event) {
    var close = event.target.closest('[data-video-close]');
    if (close) { closePlayer(close.closest('[data-video-player]')); return; }
    var button = event.target.closest('[data-video-play]');
    if (!button) return;
    var media = button.closest('.collector-video-card__media');
    var player = media.querySelector('[data-video-player]');
    var content = player.querySelector('[data-video-player-content]');
    var nativeTemplate = media.querySelector('[data-native-video]');
    if (nativeTemplate) {
      content.appendChild(nativeTemplate.content.cloneNode(true));
      player.hidden = false;
      var video = content.querySelector('video');
      if (video) video.play().catch(function () {});
      player.querySelector('[data-video-close]').focus();
      return;
    }
    var src = videoSource(button);
    if (!src) return;
    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = button.getAttribute('aria-label') || 'Video player';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture';
    iframe.allowFullscreen = true;
    content.appendChild(iframe);
    player.hidden = false;
    player.querySelector('[data-video-close]').focus();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var player = document.querySelector('[data-video-player]:not([hidden])');
    if (player) closePlayer(player);
  });

  function setupGallery(section) {
    if (section.dataset.galleryReady === 'true') return;
    var gallery = section.querySelector('[data-gallery]');
    if (!gallery) return;
    section.dataset.galleryReady = 'true';
    var grid = gallery.querySelector('[data-video-grid]');
    var controls = section.querySelector('[data-gallery-controls]');
    var search = controls.querySelector('[data-video-search]');
    var brand = controls.querySelector('[data-brand-filter]');
    var category = controls.querySelector('[data-category-filter]');
    var status = gallery.querySelector('[data-gallery-status]');
    var more = gallery.querySelector('[data-load-more]');
    var pagination = gallery.querySelector('[data-gallery-pagination]');
    var nextUrl = gallery.dataset.nextUrl;
    var limit = 12;
    var fetchPromise = null;
    var debounceTimer;
    var generation = 0;
    controls.hidden = false;
    if (pagination) pagination.hidden = true;

    function cards() { return Array.from(grid.querySelectorAll('[data-video-card]')); }
    function sortableDate(card) {
      var value = card.dataset.publishDate || '';
      return /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : '';
    }
    function sortCards() {
      cards().sort(function (a, b) {
        var aDate = sortableDate(a);
        var bDate = sortableDate(b);
        if (aDate !== bDate) return aDate > bDate ? -1 : 1;
        var aId = a.dataset.videoId || '';
        var bId = b.dataset.videoId || '';
        if (aId.length !== bId.length) return bId.length - aId.length;
        if (aId !== bId) return aId > bId ? -1 : 1;
        return 0;
      }).forEach(function (card) { grid.appendChild(card); });
    }
    function updateSelect(select, key) {
      var selected = select.value;
      var values = [...new Set(cards().map(function (card) { return card.dataset[key]?.trim(); }).filter(Boolean))].sort(function (a, b) { return a.localeCompare(b); });
      select.options.length = 1;
      values.forEach(function (value) { select.add(new Option(value, value)); });
      select.value = selected;
    }
    function updateOptions() { updateSelect(brand, 'brand'); updateSelect(category, 'category'); }
    function filtered() {
      var query = search.value.trim().toLocaleLowerCase();
      return cards().filter(function (card) {
        return (!query || (card.dataset.search || '').includes(query)) &&
          (!brand.value || card.dataset.brand === brand.value) &&
          (!category.value || card.dataset.category === category.value);
      });
    }
    function show() {
      var matches = filtered();
      var visible = new Set(matches.slice(0, limit));
      cards().forEach(function (card) { card.hidden = !visible.has(card); });
      var count = Math.min(limit, matches.length);
      status.textContent = cards().length === 0 && !nextUrl ? 'No videos yet. Add published Collector Video entries to show them here.' : nextUrl ? 'Showing ' + count + ' videos. More videos are available.' : 'Showing ' + count + ' of ' + matches.length + ' videos.';
      more.hidden = matches.length <= limit && !nextUrl;
    }
    async function fetchNext() {
      if (!nextUrl) return false;
      if (fetchPromise) return fetchPromise;
      var pending = (async function () {
        var url = new URL(nextUrl, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Invalid page URL');
        var response = await fetch(url.href, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Page request failed');
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var incoming = doc.getElementById(section.id)?.querySelector('[data-gallery]');
        if (!incoming) throw new Error('Gallery page missing');
        incoming.querySelectorAll('[data-video-card]').forEach(function (card) { grid.appendChild(document.importNode(card, true)); });
        nextUrl = incoming.dataset.nextUrl;
        updateOptions();
        if (!nextUrl) {
          brand.disabled = false;
          category.disabled = false;
        }
        return true;
      })();
      fetchPromise = pending;
      pending.then(
        function () { if (fetchPromise === pending) fetchPromise = null; },
        function () { if (fetchPromise === pending) fetchPromise = null; }
      );
      return pending;
    }
    async function refresh(fetchAll) {
      var current = ++generation;
      more.disabled = true;
      try {
        if (fetchAll) {
          status.textContent = 'Searching all videos…';
          while (nextUrl) await fetchNext();
        } else {
          while (nextUrl && filtered().length < limit) await fetchNext();
        }
        if (current === generation) { sortCards(); show(); }
      } catch (error) {
        status.textContent = 'Could not load all videos. Please try again or use the page links.';
        if (pagination) pagination.hidden = false;
      } finally { more.disabled = false; }
    }
    function filterChange() {
      limit = 12;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { refresh(Boolean(search.value.trim() || brand.value || category.value)); }, 180);
    }
    search.addEventListener('input', filterChange);
    brand.addEventListener('change', filterChange);
    category.addEventListener('change', filterChange);
    more.addEventListener('click', function () { limit += 12; refresh(false); });
    updateOptions();
    if (nextUrl) {
      grid.style.display = 'none';
      search.disabled = true;
      brand.disabled = true;
      category.disabled = true;
      status.textContent = 'Loading videos in date order…';
      (async function () {
        try {
          while (nextUrl) await fetchNext();
          sortCards();
          grid.style.removeProperty('display');
          search.disabled = false;
          brand.disabled = false;
          category.disabled = false;
          show();
        } catch (error) {
          sortCards();
          grid.style.removeProperty('display');
          status.textContent = 'Could not load all videos in date order. Please try again or use the page links.';
          if (pagination) pagination.hidden = false;
        }
      })();
    } else { sortCards(); show(); }
  }

  function init() { document.querySelectorAll('[data-collector-section]').forEach(setupGallery); }
  window.ToyvixCollectorVideos = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
